// This file is generated using scripts/generate-icon-components/utils.js
// Don't edit it manually

import React from 'react';

const IconBoldSmiley = (
  {
    size,
    style,
    ...rest
  }: React.HTMLAttributes<SVGElement> & { size?: number } /*#__PURE__*/,
) =>
  React.createElement(
    'svg',
    {
      style: { width: size, height: size, ...style },
      ...rest,
      xmlns: 'http://www.w3.org/2000/svg',
      width: '24',
      height: '24',
      viewBox: '0 0 14 14',
      fill: 'none',
    },
    /*#__PURE__*/ React.createElement(
      'g',
      {
        clipPath: 'url(#clip0_1140_3232)',
      },
      /*#__PURE__*/ React.createElement('path', {
        d: 'M7.00065 0.333008C5.68211 0.333008 4.39318 0.724001 3.29685 1.45654C2.20052 2.18909 1.34604 3.23028 0.841457 4.44845C0.336873 5.66663 0.204851 7.00707 0.462085 8.30028C0.71932 9.59348 1.35426 10.7814 2.28661 11.7137C3.21896 12.6461 4.40684 13.281 5.70005 13.5382C6.99326 13.7955 8.3337 13.6635 9.55188 13.1589C10.77 12.6543 11.8112 11.7998 12.5438 10.7035C13.2763 9.60715 13.6673 8.31822 13.6673 6.99967C13.6654 5.23215 12.9624 3.53757 11.7126 2.28774C10.4628 1.03791 8.76818 0.33492 7.00065 0.333008V0.333008ZM4.77843 4.77745C5.07312 4.77745 5.35573 4.89452 5.56411 5.10289C5.77248 5.31126 5.88954 5.59388 5.88954 5.88856C5.88954 6.44412 5.39232 6.44412 4.77843 6.44412C4.16454 6.44412 3.66732 6.44412 3.66732 5.88856C3.66732 5.59388 3.78438 5.31126 3.99276 5.10289C4.20113 4.89452 4.48375 4.77745 4.77843 4.77745V4.77745ZM10.1484 9.08079C9.26628 9.83441 8.15942 10.2747 7.00065 10.333C5.84189 10.2747 4.73502 9.83441 3.85288 9.08079C3.74296 8.98266 3.67652 8.84488 3.66819 8.69777C3.66406 8.62493 3.67432 8.55198 3.69839 8.48311C3.72245 8.41423 3.75984 8.35077 3.80843 8.29634C3.85702 8.24191 3.91585 8.19759 3.98157 8.1659C4.04729 8.13422 4.11861 8.11578 4.19145 8.11165C4.33856 8.10332 4.48296 8.15377 4.59288 8.2519C5.27189 8.82306 6.11533 9.16285 7.00065 9.2219C7.8865 9.16281 8.73039 8.8226 9.40954 8.25079C9.46404 8.20227 9.52756 8.16496 9.59648 8.14099C9.66539 8.11703 9.73836 8.10687 9.8112 8.1111C9.88404 8.11533 9.95534 8.13387 10.021 8.16565C10.0867 8.19743 10.1455 8.24184 10.194 8.29634C10.2425 8.35084 10.2798 8.41436 10.3038 8.48328C10.3277 8.55219 10.3379 8.62516 10.3337 8.698C10.3294 8.77084 10.3109 8.84214 10.2791 8.90781C10.2473 8.97349 10.2029 9.03227 10.1484 9.08079V9.08079ZM9.22287 6.44412C8.60899 6.44412 8.11176 6.44412 8.11176 5.88856C8.11176 5.59388 8.22883 5.31126 8.4372 5.10289C8.64557 4.89452 8.92819 4.77745 9.22287 4.77745C9.51756 4.77745 9.80018 4.89452 10.0085 5.10289C10.2169 5.31126 10.334 5.59388 10.334 5.88856C10.334 6.44412 9.83676 6.44412 9.22287 6.44412Z',
        fill: 'currentColor',
      }),
    ),
    /*#__PURE__*/ React.createElement(
      'defs',
      null,
      /*#__PURE__*/ React.createElement(
        'clipPath',
        {
          id: 'clip0_1140_3232',
        },
        /*#__PURE__*/ React.createElement('rect', {
          width: '13.3333',
          height: '13.3333',
          fill: 'white',
          transform: 'translate(0.333984 0.333008)',
        }),
      ),
    ),
  );

export { IconBoldSmiley };
